import { EleicaoResponseType } from '../../types';
import { TextField } from '../../components';

function remocaoEleicaoModalContent(eleicao: EleicaoResponseType, t: Function): Function {
  return (props: any) => (
    <>
      <div className="alert alert-danger" role="alert">
        <p>
          <strong>{t('texto.modal_remocao_eleicao_parte_1')}</strong>
        </p>
        <p>{t('texto.modal_remocao_eleicao_parte_2')}</p>
      </div>
      <div>
        <p>{t('texto.modal_remocao_eleicao_parte_3')}</p>
      </div>
      <div>
        <p className="mb-0">{t('texto.modal_remocao_eleicao_parte_4')}</p>
        <pre className="mb-0">{eleicao.titulo}</pre>
      </div>
      <div>
        <TextField formikProps={props} name="titulo_eleicao" label="" showValidationErrors={false} />
      </div>
    </>
  );
}

export default remocaoEleicaoModalContent;
